export type SignatureCanvasRect = {
  left: number;
  top: number;
  width: number;
  height: number;
};

export type SignatureCanvasPointInput = {
  clientX: number;
  clientY: number;
  rect: SignatureCanvasRect;
  canvasWidth: number;
  canvasHeight: number;
};

export const resolveSignatureCanvasPoint = ({
  clientX,
  clientY,
  rect,
  canvasWidth,
  canvasHeight,
}: SignatureCanvasPointInput): { x: number; y: number } => {
  const scaleX = rect.width > 0 && canvasWidth > 0
    ? canvasWidth / rect.width
    : 1;
  const scaleY = rect.height > 0 && canvasHeight > 0
    ? canvasHeight / rect.height
    : 1;

  return {
    x: (clientX - rect.left) * scaleX,
    y: (clientY - rect.top) * scaleY,
  };
};
